import React from "react";
import { DiseaseCluster } from "fe-common/hooks/sortFeaturesWithCrs";
import { DDClinicalReasoning } from "fe-common/graphql/dao";
import { Citations } from "fe-web-components/citations/Citations";

//region [[ Styles ]]
//const ReferencesView = styled("div")(({ theme }) => ({}));
//endregion [[ Styles ]]

//region [[ Props ]]
export interface ReferencesProps {
  fWithCrs: DiseaseCluster;
  selectedCR: DDClinicalReasoning;
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const References = ({ fWithCrs, selectedCR }: ReferencesProps) => {
  const citations = selectedCR
    ? selectedCR.diseaseCitations
    : fWithCrs.citations;
  return <Citations citations={citations} />;
};
